import { AnimatePresence, motion } from "motion/react";
import clsx from "clsx";
import { IS_DEV } from "@/domains/main/constants/other";
import useKeyboardEvent from "@/domains/spawn/hooks/useKeyboardEvent";
import useShowSpawn from "@/domains/spawn/hooks/useShowSpawn";
import SpawnListLocationsContainer from "@/domains/spawn/containers/SpawnListLocationsContainer";
import SpawnNavigationContainer from "@/domains/spawn/containers/SpawnNavigationContainer";

export default function SpawnContainer() {
  const { isShow } = useShowSpawn();
  useKeyboardEvent();

  const show = isShow || IS_DEV;

  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 1,
          }}
          exit={{
            opacity: 0,
          }}
          className={clsx(
            "fixed top-0 right-0 left-0 bottom-0 px-[--boundary-offset-x] py-[--boundary-offset-y]",
            "bg-no-repeat",
          )}
        >
          <div className="relative w-full h-full">
            <SpawnNavigationContainer className="absolute left-0 bottom-0" />
            <SpawnListLocationsContainer className="absolute left-[50%] bottom-0 -translate-x-[50%]" />
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
